import { Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";

import { getAllEnterprises } from "../../lib/api";
import { Enterprise } from "../../types/dataTypes";
import { useSnackbar } from "../useSnackbar";

/**
 * Hook that handles the fetching logic for the enterprise data
 */

export const useEnterprises = (userId?: number) => {
  const { showSnackbar } = useSnackbar();

  const { data, isLoading } = useQuery(
    ["enterprises", userId],
    async () => getAllEnterprises(userId),
    {
      refetchOnWindowFocus: false,
      onError: () => {
        showSnackbar(
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="subtitle2">
              Oops, we couldn&apos;t load your data
            </Typography>
            <Typography variant="body2">
              Please refresh the page to try again
            </Typography>
          </div>,
          "error"
        );
      },
    }
  );

  return { enterprises: (data || []) as Enterprise[], isLoading };
};
